module.exports = __webpack_public_path__ + "static/media/unit 5-4.7c31402b.jpg";